<template>
  <aside class="aside-menu-hidden"></aside>
</template>

<script>
export default {
  name: 'c-aside'
}
</script>
